export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default sticky-top navbar-fixed-top">
      <div className="container">
        <div className="navbar-header"> 
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            <img src="img/logo.png" alt="logo" />
          </a>
        </div>
        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll">
                Miért
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                Rólam
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                Szolgáltatásaim
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                Munkáim
              </a>
            </li>
            <li>
              <a href="#testimonials" className="page-scroll">
                Vélemények
              </a>
            </li>
            <li>
              <a
                href="#contact"
                className="page-scroll"
                style={{
                  backgroundColor: "#5AC7CE",
                  color: "#fff",
                  padding: "10px 20px",
                  borderRadius: "4px",
                  marginLeft: "10px",
                  marginTop: "8px",
                  display: "inline-block",
                }}
              >
                Kontakt
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
